import React from "react";
import { Globe } from "lucide-react";
import { useI18n } from "../lib/i18n";

export function LangSwitch({ className = "" }) {
  const { lang, toggle } = useI18n();
  return (
    <button
      onClick={toggle}
      data-testid="lang-switch"
      title="Switch language / 切换语言"
      className={`group inline-flex shrink-0 items-center gap-2 rounded-full border border-edge raise px-3 py-1.5 transition-colors duration-200 hover:border-aegis-cyan/40 ${className}`}
    >
      <Globe size={13} className="text-slate-400 group-hover:text-aegis-cyan transition-colors duration-200" />
      <span className={`font-mono text-[11px] ${lang === "zh" ? "text-aegis-cyan" : "text-slate-400"}`}>中文</span>
      <span className="text-slate-500">/</span>
      <span className={`font-mono text-[11px] ${lang === "en" ? "text-aegis-cyan" : "text-slate-400"}`}>EN</span>
    </button>
  );
}
